<template>
  <div class="animated fadeIn">
    <b-form v-on:submit.prevent="onSubmit" @reset="setEmptyForm">
      <b-card title="Change Password" sub-title="">
        <progress-loader ref="progress"></progress-loader>
        <b-form-row>
          <b-col md="12">
            <div v-if="errorMsg !== null" class="alert alert-danger" v-html="errorMsg"></div>
          </b-col>
          <b-col md="8">
            <b-form-group
                  label="Current Password" label-for="currentPassword"
                  label-class="font-weight-bold"
                  label-cols="5" :horizontal="true">
              <b-form-input
                    id="currentPassword"
                    type="password"
                    v-model="account.currentPassword.value"/><span class="required-input-sign">*</span>
              <div v-if="account.currentPassword.error !== null"
                    role="alert"
                    aria-live="assertive"
                    aria-atomic="true"
                    class="invalid-feedback d-block">{{account.currentPassword.error}}</div>
            </b-form-group>
            <b-form-group
                  label="New Password" label-for="newPassword"
                  label-class="font-weight-bold"
                  label-cols="5" :horizontal="true">
              <b-form-input
                    id="newPassword"
                    type="password"
                    v-model="account.newPassword.value"/><span class="required-input-sign">*</span>
              <div v-if="account.newPassword.error !== null"
                    role="alert"
                    aria-live="assertive"
                    aria-atomic="true"
                    class="invalid-feedback d-block">{{account.newPassword.error}}</div>
            </b-form-group>
            <b-form-group
                  label="Confirm Password" label-for="confirmPassword"
                  label-class="font-weight-bold"
                  label-cols="5" :horizontal="true">
              <b-form-input
                    id="confirmPassword"
                    type="password"
                    v-model="account.confirmPassword.value"/><span class="required-input-sign">*</span>
              <div v-if="account.confirmPassword.error !== null"
                    role="alert"
                    aria-live="assertive"
                    aria-atomic="true"
                    class="invalid-feedback d-block">{{account.confirmPassword.error}}</div>
            </b-form-group>
          </b-col>
        </b-form-row>
        <div slot="footer">
          <b-row>
            <b-col md="6" lg="3" class="d-md-down-none">
              <b-button
                    size="md"
                    href='#/profile'
                    variant="light"
                  class="btn-pill">
                <i class="fa fa-arrow-left"></i> Back
              </b-button>
            </b-col>
            <b-col md="6" lg="3" class="text-right">
              <b-button
                    type="reset"
                    size="md"
                    variant="danger"
                    class="btn-pill">
                <i class="fa fa-ban"></i> Reset
              </b-button> 
              <b-button
                    type="submit"
                    size="md"
                    variant="primary"
                    class="btn-pill">
                <i class="fa fa-dot-circle-o"></i> Submit
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-form>
  </div>
</template>

<script>
import axios from 'axios'
import progressLoader from '@/views/components/progressLoader'

export default {
  name: 'ChangePassword',
  components: {
    progressLoader
  },
  data () {
    return {
      apiUrl: window.AppConfig.apiUrl + 'change-password',
      showLoader: false,
      errorMsg: null,
      account: {
        currentPassword: {
          rule: 'required editable',
          value: null,
          error: null
        },
        newPassword: {
          rule: 'required editable',
          value: null,
          error: null
        },
        confirmPassword: {
          rule: 'required editable',
          value: null,
          error: null
        }
      }
    }
  },
  methods: {
    onSubmit () {
      // init var
      this.errorMsg = null
      let hasError = false
      let obj = Object.keys(this.account)
      // validating
      for (let i = 0; i < obj.length; i++) {
        let rule = this.account[obj[i]].rule
        if (
          (
            rule.indexOf('required') !== -1 ||
            (
              this.isEditMode &&
              rule.indexOf('editable') !== -1 &&
              rule.indexOf('required') !== -1
            )
          ) &&
          (this.account[obj[i]].value === null || this.account[obj[i]].value === '' || this.account[obj[i]].value.HH === null)
        ) {
          this.account[obj[i]].error = 'This field is required'
          hasError = true
        } else if (obj[i] === 'confirmPassword' && (this.account.newPassword.value !== this.account.confirmPassword.value)) {
          this.account[obj[i]].error = 'New Password & Confirm Password does not match'
          hasError = true
        } else {
          this.account[Object.keys(this.account)[i]].error = null
        }
      }
      if (hasError) {
        this.$refs.progress.deactivateProgressBar()
        this.$alertify.error('Failed! Please complete the message and submit again.')
        return false
      }

      // collect data
      let formData = {
        'currentPassword': null,
        'newPassword': null,
        'confirmPassword': null
      }
      for (let i = 0; i < Object.keys(this.account).length; i++) {
        let key = Object.keys(this.account)[i]
        formData[key] = this.account[key].value
      }
      var self = this
      self.$refs.progress.activateProgressBar()
      // submit data
      axios.post(this.apiUrl, formData)
        .then(response => {
          self.$refs.progress.deactivateProgressBar()
          self.setEmptyForm()
          self.$alertify.success('Password Has Been Changed!')
          window.location.href = document.URL.replace('/profile/password', '/profile')
        })
        .catch(error => {
          self.doCollectErrMessage(error)
        })
    },

    setEmptyForm () {
      this.account.currentPassword.value = null
      this.account.newPassword.value = null
      this.account.confirmPassword.value = null
    },

    doCollectErrMessage (error) {
      this.$refs.progress.deactivateProgressBar()
      this.$alertify.error('Failed! Please complete the message and submit again.')
      this.$store.dispatch('errorMessage', error)
        .then(errMsg => {
          this.errorMsg = errMsg
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user-profile/ChangePassword.vue